// @ts-nocheck

import { EventType, InteractionType, PublicClientApplication } from "@azure/msal-browser";
import {
    MsalAuthenticationTemplate,
    MsalProvider
} from "components/common/msal";
import "promise-polyfill/src/polyfill";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import "whatwg-fetch";
import App from "./App";
import "./css/animations.css";
import "./css/font.css";
import "./css/icomoon-font.css";
import "./css/responsive.dataTables.min.css";
import "./css/site.css";
import "./css/style.css";
import getTenantName from "./utils/getTenantName";


export const instance: PublicClientApplication;

async function renderApp() {
    // This code starts up the React app when it runs in a browser. It sets up the routing
    // configuration and injects the app into a DOM element.
    (window as any).SITE_NAME = await getTenantName();
    (window as any).BQS = SITE_NAME?.toString() == "BQS";
    (window as any).CQS = !BQS;

    // Load environment-specific configuration from .env file
    const configurationBQS: Configuration;
    const configurationCQS: Configuration;

    const environment = window.ENVIRONMENT_VAR;
    (window as any).HostingEnv = environment;
    const config = require(`./config.${environment}.ts`);

    configurationBQS = config.configurationBQS;

    configurationCQS = config.configurationCQS;

    instance = BQS ? new PublicClientApplication(configurationBQS) : new PublicClientApplication(configurationCQS);

    // Default to using the first account if no account is active on page load
    if (!instance.getActiveAccount() && instance.getAllAccounts().length > 0) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        instance.setActiveAccount(instance.getAllAccounts()[0]);
    }

    // Optional - This will update account state if a user signs in from another tab or window
    instance.enableAccountStorageEvents();

    instance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
            const account = event.payload.account;
            instance.setActiveAccount(account);
        }
    });

    ReactDOM.render(
        <MsalProvider instance={instance}>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={BQS ? config.authRequestBQS : config.authRequestCQS}
                errorComponent={ErrorComponent}
                loadingComponent={LoadingComponent}
            >
                <AppContainer>
                    <App BQS={BQS} />
                </AppContainer>
            </MsalAuthenticationTemplate>
        </MsalProvider>,
        document.getElementById("react-app")
    );
}

renderApp();

// Allow Hot Module Replacement
if (module.hot) {
    module.hot.accept("./routes", () => {
        routes = require<typeof RoutesModule>("./routes").routes;
        renderApp();
    });
}

function ErrorComponent({ error }) {
    console.log("err", error);
    return <p>An Error Occurred: {error}</p>;
}

function LoadingComponent() {
    return (
        <div
            style={{
                background: "rgba(0,0,0,0.3)",
                width: "100vw",
                height: "100vh",
                zIndex: "1000",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <p style={{ color: "white" }}>Authentication in progress....</p>
        </div>
    );
}



// WEBPACK FOOTER //
// ./ClientApp/boot.tsx